//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

    /**
     * Radio button set used as a search filter control.
     * @param {Object[]} options - Array of objects for what options should be available from these radio buttons
     * @param {string} options[].value - value which this component will output to its filter when this option is selected. This can be null or
     * undefined to use this option to clear the value from the filter.
     * @param {string} options[].label - label used for this option
     * @param {Function} conditionalChange - A function to confirm that a newly selected value is valid before resetting the filter
     */
  curalate.component('searchFilterRadioButtons', {
    bindings: {
      options: '<',
    },
    require: {
      searchFilter: '^searchFilter',
    },
    template: require('@legacy-components/filters/search-filter-radio-buttons.html'),
    controller: [
      function() {
        const self = this;

        self.value = null;

        this.$onInit = function() {
          const currentSearchFilterValue = self.searchFilter.getValue();

          let initialOption = _(self.options).find(option => _(currentSearchFilterValue).contains(option.value));

          if (!initialOption) {
                        // default to first value if filter doesn't specify a default
            initialOption = self.options[0];
          }

          if (initialOption && initialOption.value !== undefined && initialOption.value !== null) {
            self.value = initialOption.value;
            if (!_(currentSearchFilterValue).contains(initialOption.value)) {
              self.searchFilter.setValue(initialOption.value);
            }
          }

          self.lockedKey = self.searchFilter.isKeyLocked();

          _(self.options).each((option) => {
            if (option.value !== null) {
              self.searchFilter.registerFilterOptionAlias(option.value, option.label);
            }
          });

          self.searchFilter.getFilterValueStream().subscribe((newState) => {
                        // When the value stream is updated outside of this directive, set the new value of the dropdown accordingly
                        // Since a dropdown can only have one option set at a time, get the value of the first option if it exists
            const newValue = _(newState).safeGet('0') || null;
            self.value = newValue;
          });
        };

        self.onChange = (value) => {
          const currentValue = _(self.searchFilter.getValue()).safeGet('0');
          if (value === null || value === undefined) {
            self.searchFilter.clearValues();
          } else if (value !== currentValue) {
            self.searchFilter.setValue(value);
          }
        };
      },
    ],
  });
})();
